import cx from 'classnames';
import * as React from 'react';

import './styles/SidebarFooter.scss';

type Props = {
  children: React.ReactNode;
  noShadow?: boolean;
};

// In order for this to correct fill the width of the enclosing sidebar,
// the width of the sidebar needs to be explicitly set in CSS using
// exact values (ie. not using percentages or flex)
export default function SidebarFooter(props: Props) {
  return (
    <footer className={cx('SidebarFooter', props.noShadow && 'SidebarFooter--noShadow')}>
      {props.children}
    </footer>
  );
}
